import { Component, inject, ChangeDetectionStrategy } from "@angular/core";
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from "@angular/forms";
import { TranslateModule } from "@ngx-translate/core";
import { DynamicDialogConfig, DynamicDialogRef } from "@openng/optimus-ui/dynamicdialog";
import { InputTextModule } from "@openng/optimus-ui/inputtext";
import { ButtonComponent } from "../../../../../shared/components/button/button.component";
import { FaultList, FaultListObject } from "../../../../../models/api/fault/faultList";

@Component({
  standalone: true,
  selector: "app-fault-list",
  imports: [ButtonComponent, ReactiveFormsModule, TranslateModule, InputTextModule],
  templateUrl: "./fault-list.component.html",
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: "./fault-list.component.scss",
})
export class FaultListComponent {
  private config = inject(DynamicDialogConfig);
  private ref = inject(DynamicDialogRef);

  private faultList = new FaultList(this.config.data.faultList);
  public form = new FormGroup({
    label: new FormControl(this.faultList.label, Validators.required),
  });

  /**
   * Saves the changes to the FaultList and closes the dialog.
   * If the form is invalid, the dialog remains open.
   */
  public save() {
    const faultListValues = this.form?.value;

    if (this.form.valid && faultListValues && faultListValues.label) {
      const faultList: FaultListObject = { label: faultListValues.label };
      this.faultList.properties = faultList;
      this.ref.close(this.faultList);
    }
  }

  /**
   * Closes the dialog without returning any result.
   */
  public closeDialog() {
    this.ref.close();
  }
}
